<template>
	<div>
		<el-dialog
		 title="宠物档案"
		 :class="size"
		 :visible.sync="dialogFormVisible"
		 @close="submitTap"
		 >
			<el-button @click="petData(0)" class="pa_btn" size="max" type="FF7">新增宠物</el-button>
			<!-- <el-button @click="petNotice(0)" class="pa_btn" size="max" type="FF7">新增提醒</el-button> -->
			<div class="pa_table_box">
				<el-table
					:data="petDataList"
					style="width: 100%"
					v-loading="loading"
				>
					<el-table-column prop="pet_nickname" width="180" label="宠物昵称" align="center"></el-table-column>
					<el-table-column width="120" label="宠物类别" align="center">
						<template slot-scope="{row}">
							<span>{{row.pet_type == 'dog' ? '狗狗' : row.pet_type == 'cat' ? '猫咪' : '其他' }}</span>
						</template>
					</el-table-column>
					<el-table-column width="100" prop="breed_name" label="宠物品种" align="center"></el-table-column>
					<el-table-column label="宠物性别" align="center">
						<template slot-scope="{row}">
							<span>{{row.pet_sex == '0' ? '公' : '母'}}</span>
						</template>
					</el-table-column>
					<!-- <el-table-column prop="pet_age" label="宠物年龄"></el-table-column> -->
					<el-table-column prop="pet_birthday" label="宠物生日" align="center"></el-table-column>
					<el-table-column prop="pet_color" label="宠物毛色" align="center"></el-table-column>
					<!-- <el-table-column prop="pet_fur" label="宠物长短毛"></el-table-column> -->
					<el-table-column prop="pet_weight" label="宠物体重" align="center"></el-table-column>
					<el-table-column prop="pet_height" label="宠物身高" align="center"></el-table-column>
					<el-table-column label="是否绝育" align="center">
						<template slot-scope="{row}">
							<span>{{row.pet_sterilization == '0' ? '否' : '是'}}</span>
						</template>
					</el-table-column>
					<el-table-column label="是否疫苗" align="center">
						<template slot-scope="{row}">
							<span>{{row.pet_vaccine == '0' ? '否' : '是'}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="zip" label="操作" align="center">
						<template slot-scope="{ row }">
							<!-- <el-button @click="petNotice(scope.row.pet_id)" size="text" class="list_button">提醒</el-button> -->
							<el-button @click="petData(row.pet_id)" size="text" class="list_button">编辑</el-button>
							<el-button @click="delPet(row.pet_id)" size="text" class="list_button">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</el-dialog>
		<alertPop :status="delPetVisible" size="mini" :conText="delPetContent" type="2" @clock="delPetCloseTap"></alertPop>
		<addNotice :status="addNoticeVisible" :uid="uid" :petId="current_pet_id" @add="petNoticeTap"></addNotice>
		<addPet :status="addPetVisible" :userId="uid" :petId="current_pet_id" @add="petDataTap"></addPet>
	</div>
</template>

<script>
	import alertPop from '@/components/common/alertPop.vue'
	import addNotice from '@/components/common/addNotice.vue'
	import addPet from '@/components/common/addPet.vue'
	export default {
		name:'petList',
		props:['status','size','uid'],
		components:{
			alertPop,
			addNotice,
			addPet,
		},
		data() {
		  return {
			loading: false,
			petDataList:[],
			dialogFormVisible:false,
			addPetVisible:false,
			addNoticeVisible:false,
			delPetVisible:false,
			current_uid:'',
			current_pet_id:'',
			delPetContent:'是否删除该宠物,是请确认?',
			formLabelWidth: '120px',

		  };
		},
		watch:{
			status(val){
				 this.dialogFormVisible = val;
				 this.current_uid = this.uid;
			},
			dialogFormVisible(newVal,oldVal) {
				if ((newVal != oldVal) && newVal) {
					this.initPetsList()
				}
			}
		},
		methods:{
			initPetsList() {
				this.loading = true;
				this.$ajax({
					'method' : 'com.get.merchant_user.pet.list',
					'data': { 'user_id': this.current_uid }
				}).then(res => {
					if (res.status = 10000) {
						this.petDataList = res.data.list;
					} else {
						this.$message.error(res.info);
					}
					this.loading = false;
				})
			},
			//宠物提醒
			petNotice(pet_id){
				this.current_pet_id = pet_id;
				this.addNoticeVisible = true;
			},
			//宠物提醒回调
			petNoticeTap(val){
					this.addNoticeVisible = val;
			},
			//删除宠物档案回调
			delPetCloseTap(val,type){
				if(type == '2'){
					this.$ajax({
						'method' : 'com.set.merchant_user.pet.delete',
						'data': { 'user_id': this.current_uid, 'pet_id': this.current_pet_id }
					}).then(res => {
						if (res.status = 10000) {
							this.initPetsList();
							this.$message.success('删除成功');
						} else {
							this.$message.error(res.info);
						}
					})
				}
				this.delPetVisible = val;
			},
			//删除宠物档案记录
			delPet(pet_id){
				this.delPetVisible = true;
				this.current_pet_id = pet_id;
			},
			//新增宠物
			petData(pet_id){
				this.addPetVisible = true;
				this.current_pet_id = pet_id;
			},
			//宠物数据回调
			petDataTap(val,type){
				if (type == 'save') {
					this.initPetsList();
				}
				this.current_pet_id = 0;
				this.addPetVisible = val;
			},
			//弹框关闭回调
			submitTap(type,obj){
				this.dialogFormVisible = false;
				this.petDataList = [];
				this.$emit('add',false,'')
			},
		}
	}

</script>
<style scoped lang="scss">
	@import '~scss_vars';
	.pa_btn{width:110px;font-size:12px;}
	.pa_btn.on{background:#FF700B;color:#fff;}
	.search_user_box{height:70px;}
	.pa_main_add_btn{font-size:16px;margin-top:18px;line-height:24px;font-weight:'bold';background:#fff;color:#999;text-align:center;}
	.pa_main_status_box{display:flex;}
	.pa_main_status_box .cols{width:16.6%;margin-left:10px;height:70px;padding:14px 0;color:#fff;border-radius:10px;text-align:center;}
	.pa_main_status_box .cols .numbers{font-size:34px;}
	
	.pa_main_search_inner{display:flex;padding:18px 0;}
	
	.pa_user_info_box{
		background:#fff;border-radius:10px;
		.img{
			width:60px;height:60px;border-radius:50%;
		}
		.text{
			padding:0 0 0 10px;
			.labels{display:block;width:40px;line-height:18px;margin-top:5px;background:#FF700B;text-align:center;color:#fff;font-size:12px;border-radius:6px;}
		}
		.el-icon-arrow-right{position:absolute;right:0;font-size:20px;}
		.over,.card{
			width:50%;text-align:center;
			span{display:block;margin-bottom:5px;font-size:18px;}
		}
		.pa_btn{margin-left:0;}
	}
</style>


// WEBPACK FOOTER //
// petList.vue?65c150d2